import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { operationsRpc } from '@/lib/operations';
import { refreshSaleConsumers } from '@/lib/refreshSaleConsumers';
export function useOperations() {
  const { organization, profile, access } = useAuth();
  return useQuery({
    queryKey: ['operations_contract', organization?.id, profile?.id, access?.access_version],
    enabled: !!organization && !!profile,
    retry: false,
    queryFn: async () => {
      try {
        return await operationsRpc<{ contract_version: number; modules: Record<string, number> }>(
          'get_operations_contract',
        );
      } catch (e) {
        if ((e as { code?: string }).code === 'MIGRATION_REQUIRED') return null;
        throw e;
      }
    },
  });
}
export function useOperation<
  T extends { success: boolean; contract_version?: number } = {
    success: boolean;
    purchase_id: string;
  },
>(name: string) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async (input: Record<string, unknown>) => {
      const result = await operationsRpc<T>(name, { p_data: { ...input, contract_version: 1 } });
      if (!result?.success || result.contract_version !== 1)
        throw new Error('The operation was not confirmed. Recover before retrying.');
      return result;
    },
    onSuccess: () => refreshSaleConsumers(client),
  });
}
